import type { AxiosRequestConfig, AxiosResponse } from 'axios';

import client from 'api/client';
import type { LicenseListResponse, LicenseUpdateRequest } from 'types';

export function get(
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<LicenseListResponse>> {
    return client.get<LicenseListResponse>('/licenses', customConfig);
}

export function put(
    payload: LicenseUpdateRequest,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<LicenseListResponse>> {
    return client.put<LicenseListResponse>('/licenses', payload, customConfig);
}
